import * as React from 'react';
import { Box, Container, Grid } from '@mui/material';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Typography from '@mui/material/Typography';
import CostCenterTable from './Table/CostCenterTab';
import PoTable from './Table/PoTab';
import ClientSiteTable from './Table/ClientSiteTab';
import InvoiceTable from './Table/InvoiceTab';
import ExpenseTable from './Table/ExpenseTab';
import SowTable from './Table/SowTab';
import ProjectTable from './Table/ProjectTab';
import TaskTable from './Table/TaskTab';
import TaskGroupsTable from './Table/TaskGroupsTab'
import LabsTable from './Table/LabsTab';
import TaskVariablesTable from './Table/TaskVariablesTab';
import { MuiThemeProvider } from '@material-ui/core/styles';
import { muiThemeDesign } from '../mui-theme-design';
import {logger, checkAuthentication} from '../utils';


interface TabPanelProps {
    children?: React.ReactNode;
    index: number;
    value: number;
}

function TabPanel(props: TabPanelProps) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box sx={{ p: 3 }}>
                    <Typography>{children}</Typography>
                </Box>
            )}
        </div>
    );
}

function a11yProps(index: number) {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`,
    };
}

export default function BillingTabs() {
    const [value, setValue] = React.useState(0);
    const [refresh, setRefresh] = React.useState(true);
	const [permissions, setPermissions] = React.useState({});
	React.useEffect(() => {
		checkAuthentication();
	    if (refresh) {
	        fetch('/api/User/Permission')
	            .then(res => res.json())
	            .then(json => setPermissions(json))
                .then(json => logger(`userTab Permissions- `, json))
	
	        setRefresh(false);
	    }
        logger(`UserTab Tab value-`, value)      
	})

    const handleChange = (event: React.SyntheticEvent, newValue: number) => {
        setValue(newValue);
    };

    return (
        <MuiThemeProvider theme={muiThemeDesign}>
        <Box sx={{ width: '100%' }}>
            <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                <Tabs variant="scrollable" value={value} onChange={handleChange} aria-label="basic tabs example"  sx={{paddingTop: {xs:8, sm:8, md: 8, lg:8, xl: 8}}}>
                    <Tab label="Cost Centers" {...a11yProps(0)} disabled={permissions.ViewCostCenter==0?true:false} />
                    <Tab label="SoW" {...a11yProps(1)} disabled={permissions.ViewSOW==0?true:false}/>
                    <Tab label="PO" {...a11yProps(2)} disabled={permissions.ViewPO==0?true:false} />
                    <Tab label="Labs" {...a11yProps(3)} disabled={permissions.ViewLab==0?true:false} />
                    <Tab label="Projects" {...a11yProps(4)} disabled={permissions.CreateTasks==0?true:false}/>
                    <Tab label="Invoice" {...a11yProps(5)} disabled={permissions.ViewFinancials==0?true:false}/>
                    <Tab label="Expense" {...a11yProps(6)} disabled={permissions.CreateExpense==0?true:false}/> 
                    <Tab label="Client Sites" {...a11yProps(7)} disabled={permissions.ViewPO==0?true:false} />                    
                </Tabs>
            </Box>
            <TabPanel value={value} index={0}>
                <CostCenterTable />
            </TabPanel>
            <TabPanel value={value} index={1}>
                <SowTable /> 
            </TabPanel>
            <TabPanel value={value} index={2}>
                <PoTable />
            </TabPanel>
            <TabPanel value={value} index={3}>
                <LabsTable />
            </TabPanel>
            <TabPanel value={value} index={4}>
                <ProjectTable />
            </TabPanel>
            <TabPanel value={value} index={5}>
                <InvoiceTable />
            </TabPanel>
            <TabPanel value={value} index={6}>
                <ExpenseTable />
            </TabPanel>
            <TabPanel value={value} index={7}>
                <ClientSiteTable />
            </TabPanel>
            </Box>
        </MuiThemeProvider>
    );
}